function numberToTime(number = 0.0) {
  const minutes = parseInt(number / 60, 10);
  const seconds = parseInt(number % 60, 10);
  function pad2(val) {
    return (val < 10 ? '0' : '') + val;
  }

  return `${pad2(minutes)}:${pad2(seconds)}`;
}

export default numberToTime;
